$( document ).ready(function() {

  // Select all anchor tags
const links = document.querySelectorAll('a');

// Iterate over each link
links.forEach(link => {
  // Check if the link is external
  if (link.hostname !== window.location.hostname) {
    // Set the target attribute to "_blank"
    link.setAttribute('target', '_blank');
  }
});
  

  $(".size-tooltip").click(function(e) {
    e.stopPropagation();
    e.preventDefault();
    $(".modal-basis").css("opacity", 1);
    $(".modal-basis").css("visibility", "visible");
  });

  $(".modal__close").click(function(e) {
    e.stopPropagation();
    e.preventDefault();
    $(".modal-basis").css("opacity", 0);
    $(".modal-basis").css("visibility", "hidden");
  });

  $(document).keydown(function(e) {
    if (e.key === "Escape") {
        $(".modal-basis").css("opacity", 0);
        $(".modal-basis").css("visibility", "hidden");
    }
  });

  $(".modal-basis").click(function(e) {
    if (!$(e.target).closest('.modal__inner').length) {
        e.preventDefault();
        $(".modal-basis").css("opacity", 0);
        $(".modal-basis").css("visibility", "hidden");
    }
});

  
  /* open thank you page modal */
  $(".thanks-popup").hide();
  $(".thanks-popup").trigger('click');

  
  /* if product is sold out, hide the price on search pages 
  if($('.grid__item.grid-product').find('.grid-product__tag--sold-out').length !== 0) {
    $(".grid-product__price", this).hide();
  }*/
  

  /* appointments landing page - choosing option from dropdown links to new page */
  
  $select = $("#cities")  //where "xxx" is the id of your select (you'll need to add an id)
  $select.change(function() {
    //get value of select and navigate to that page
    window.location = $select.val();
  });


  /* Make press images links */
  
  $(".press #shopify-section-blog-template .grid:not(.grid--uniform)").each(function(){
      $(this).children().find('.article__grid-image').attr("href", $(this).children().find('.article__grid-meta a').attr("href"));
  });

  $(".grid.press a").attr('target','_blank');
  
  $(".grid.press").click(function() { 
    var url = $(this).find("a").attr("href"); 
    window.open(url, '_blank');
  });
  
});

class promoGridItemHeight {
  constructor() {
    this.collectionGrid = document.querySelectorAll('.collection-content .collection-grid__wrapper .grid');
    this.init();
  }

  init() {
    if(!this.collectionGrid.length) return;

    this.updatePromoHeight();
    window.addEventListener('resize', this.updatePromoHeight.bind(this));
  }

  updatePromoHeight() {
    let maxHeight = 0;

    this.collectionGrid.forEach(grid => {
      const prodItems = grid.querySelectorAll('.grid-product .grid-product__content');
      const promoItems = grid.querySelectorAll('.grid-promo .grid__image-ratio');
      prodItems.forEach(item => {
        let itemHeight = item.offsetHeight;
        if(itemHeight > maxHeight) {
          maxHeight = itemHeight;
        }
      });
      promoItems.forEach(item => {
        item.style.height = `${maxHeight}px`;
      })
    })

  }
}
document.addEventListener('shopify:section:load', () => {
  new promoGridItemHeight();
});
document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.collection-content')) {
      new promoGridItemHeight();
  }
});